import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Box, InternalStandardProps } from "@mui/material";
import { isIOS } from "react-device-detect";
import { AppButton } from "./AppButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Viewer, SpecialZoomLevel, ViewMode } from "@react-pdf-viewer/core";
import { PrintPlugin } from "@react-pdf-viewer/print";
import "./AppDocument.css";

const StyledPdfIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "60px",
    color: "red",
    margin: theme.spacing(2, 0),
}));

export const AppDocument = (props: AppDocumentProps) => {
    const { fileUrl, printPlugin, loader, onLoadSuccess = () => {} } = props;

    const { handleOpenDocClick } = useHandlers(props);

    return (
        <>
            {!isIOS ? (
                <React.Fragment>
                    <Viewer
                        renderLoader={() => <>{loader}</>}
                        viewMode={ViewMode.SinglePage}
                        fileUrl={fileUrl}
                        defaultScale={SpecialZoomLevel.PageWidth}
                        onDocumentLoad={onLoadSuccess}
                        pageLayout={{
                            buildPageStyles: () => ({
                                overflow: "hidden",
                            }),
                        }}
                        plugins={[printPlugin]}
                    />
                </React.Fragment>
            ) : (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                >
                    <StyledPdfIcon icon={["fas", "file-pdf"]} />
                    <AppButton
                        buttonVariant="primary-filled"
                        onClick={handleOpenDocClick}
                    >
                        Open Document
                    </AppButton>
                </Box>
            )}
        </>
    );
};

const useHandlers = (props: AppDocumentProps) => {
    const { fileUrl, onDocumentOpen = () => {} } = props;

    useEffect(() => {
        if (!isIOS) onDocumentOpen();
    }, []);

    const handleOpenDocClick = () => {
        onDocumentOpen();
        window.open(fileUrl, "_blank", "noreferrer");
    };

    return {
        handleOpenDocClick,
    };
};

export interface AppDocumentProps
    extends Omit<InternalStandardProps<{}>, "ref"> {
    fileUrl: string;
    printPlugin: PrintPlugin;
    loader: React.ReactNode;
    onDocumentOpen?: () => void;
    onLoadSuccess?: () => void;
}
